import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortDescending'
})
export class SortDescendingPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
